import { ClientType, Company, Country, Gender, User, UserView, UserViewSimple, WorkplaceModel } from "./general";
import { WorkSession, WorkSessionView } from "./projectManagement";

// ..\mowazaf\Data\Attendance\Entities\Break.cs
export interface Break {
    id: number;
    shiftId: number;
    shift?: Shift;
    breakInTime: Date;
    breakInTimeUtc: Date;
    breakInLatitude?: number;
    breakInLongitude?: number;
    breakInClientType: ClientType;
    breakInImageUrl?: string;
    breakInComments?: string;
    breakInAddress?: string;
    breakInCountry?: string;
    breakOutTime?: Date;
    breakOutTimeUtc?: Date;
    breakOutLatitude?: number;
    breakOutLongitude?: number;
    breakOutClientType: ClientType;
    breakOutImageUrl?: string;
    breakOutComments?: string;
    breakOutAddress?: string;
    breakOutCountry?: string;
    hasEnded: boolean;
    duration?: string;
}

// ..\mowazaf\Data\Attendance\Entities\ClockingType.cs
export enum ClockingType {
    ClockIn = 'ClockIn',
    BreakIn = 'BreakIn',
    BreakOut = 'BreakOut',
    ClockOut = 'ClockOut',
    StartTask = 'StartTask',
    StopTask = 'StopTask',
}

// ..\mowazaf\Data\Attendance\Entities\DayStatus.cs
export enum DayStatus {
    Leave = 'Leave',
    Holiday = 'Holiday',
    Present = 'Present',
    SickLeave = 'SickLeave',
    WeekOffDay = 'WeekOffDay',
    HalfDayLeave = 'HalfDayLeave',
}

// ..\mowazaf\Data\Attendance\Entities\FaceRecognitionLog.cs
export interface FaceRecognitionLog {
    id: number;
    message: string;
    isRecognized: boolean;
}

// ..\mowazaf\Data\Attendance\Entities\LeaveBalanceHistory .cs
export interface LeaveBalanceHistory {
    id: number;
    userId: string;
    balanceBefore: number;
    balanceAfter: number;
    leavetypeId: number;
    action: Action;
}

// ..\mowazaf\Data\Attendance\Entities\LeaveBalanceHistory .cs
export enum Action {
    leaveRequest = 'leaveRequest',
    leaveRejection = 'leaveRejection',
    leaveApproval = 'leaveApproval',
    balanceUpdate = 'balanceUpdate',
    undoLeaveApproval = 'undoLeaveApproval',
    undoLeaveRejection = 'undoLeaveRejection',
    leaveCancellation = 'leaveCancellation',
}

// ..\mowazaf\Data\Attendance\Entities\LeaveRequestAttachment.cs
export interface LeaveRequestAttachment {
    id: number;
    name: string;
    extention: string;
    byteLength: number;
    path: string;
    userLeaveRequestId: number;
    userLeaveRequest: UserLeaveRequest;
}

// ..\mowazaf\Data\Attendance\Entities\LeaveType.cs
export interface LeaveType {
    id: number;
    name: string;
    companyId: number;
    userLeaveQuotaAndBalances?: UserLeaveQuotaAndBalance[];
}

// ..\mowazaf\Data\Attendance\Entities\LeaveType.cs
export enum QuotaType {
    Annual = 'Annual',
    Monthly = 'Monthly',
}

// ..\mowazaf\Data\Attendance\Entities\LeaveType.cs
export enum QuotaUnit {
    Days = 'Days',
    Hours = 'Hours',
}

// ..\mowazaf\Data\Attendance\Entities\OverlappedLeaveDay.cs
export interface OverlappedLeaveDay {
    id: number;
    dayOverlapped: Date;
    hoursOverlapped: number;
    userLeaveRequestId: number;
    userLeaveRequest: UserLeaveRequest;
    overlappedUserLeaveRequestId: number;
    overlappedUserLeaveRequest: UserLeaveRequest;
}

// ..\mowazaf\Data\Attendance\Entities\ScheduledShift.cs
export interface ScheduledShift {
    id: number;
    userId?: string;
    user?: User;
    startTime: Date;
    endTime: Date;
    breakStartTime?: Date;
    breakEndTime?: Date;
    breakDurationMinutes?: number | null;
    shiftId?: number;
    shift?: Shift;
}

// ..\mowazaf\Data\Attendance\Entities\ScheduleHistory.cs
export interface ScheduleHistory {
    id: number;
    userId?: string;
    user?: User;
    scheduleStartTime: Date;
    scheduleEndTime?: Date;
    weekStartEndHoursAndMinutes?: string;
}

// ..\mowazaf\Data\Attendance\Entities\Shift.cs
export interface Shift {
    id: number;
    userId?: string;
    user: User;
    clockInTime: Date;
    clockInTimeUtc: Date;
    clockInLongitude?: number;
    clockInLatitude?: number;
    clockInClientType: ClientType;
    clockInImageUrl?: string;
    clockInComments?: string;
    clockInAddress?: string;
    clockInCountry?: string;
    clockOutTime?: Date;
    clockOutTimeUtc?: Date;
    clockOutLongitude?: number;
    clockOutLatitude?: number;
    clockOutClientType: ClientType;
    clockOutImageUrl?: string;
    clockOutComments?: string;
    clockOutAddress?: string;
    clockOutCountry?: string;
    hasEnded: boolean;
    breaks?: Break[];
    workSessions?: WorkSession[];
    scheduledShift?: ScheduledShift;
}

// ..\mowazaf\Data\Attendance\Entities\ShiftUpdatesHistory.cs
export interface ShiftUpdatesHistory {
    id: number;
    shiftId?: number;
    breakId?: number;
    shiftUserId: string;
    updatedById: string;
    clockingType: ClockingType;
    oldClockTime: Date;
    newClockTime: Date;
}

// ..\mowazaf\Data\Attendance\Entities\StatusHistory.cs
export interface StatusHistory {
    id: number;
    status: string;
}

// ..\mowazaf\Data\Attendance\Entities\Timesheet.cs
export interface Timesheet {
    id: number;
    from: Date;
    to: Date;
    createdOn?: Date;
    comment: string;
    isArchived: boolean;
    userId: string;
    user: User;
    managerId: string;
    manager: User;
    timesheetStatusId: number;
    timesheetStatus: TimesheetStatus;
}

// ..\mowazaf\Data\Attendance\Entities\TimesheetStatus.cs
export interface TimesheetStatus {
    id: number;
    name: string;
}

// ..\mowazaf\Data\Attendance\Entities\UserFaceImage.cs
export interface UserFaceImage {
    id: number;
    path: string;
    userId: string;
    imageSource: ImageSource;
    user?: User;
    labeledFaceDescriptors?: string;
}

// ..\mowazaf\Data\Attendance\Entities\UserFaceImage.cs
export enum ImageSource {
    Profile = 'Profile',
    Attendance = 'Attendance',
}

// ..\mowazaf\Data\Attendance\Entities\UserLeaveQuotaAndBalance.cs
export interface UserLeaveQuotaAndBalance {
    id: number;
    eligibility: number;
    quotaUnit: QuotaUnit;
    quotaType: QuotaType;
    isCummulative: boolean;
    annuallyResets: boolean;
    includeNonWorkingrDays: boolean;
    leaveOverlapsOtherLeaves: boolean;
    balance: number;
    inheritedFromCompany: boolean;
    attachmentRequired: boolean;
    userId: string;
    user?: User;
    leaveTypeId: number;
    leaveType?: LeaveType;
}

// ..\mowazaf\Data\Attendance\Entities\UserLeaveRequest.cs
export interface UserLeaveRequest {
    id: number;
    quotaUnit: QuotaUnit;
    includeNonWorkingrDays: boolean;
    startDate: Date;
    fromHalfDay: boolean;
    fromHalfDayPart: HalfDayPart;
    endDate: Date;
    toHalfDay: boolean;
    toHalfDayPart: HalfDayPart;
    comments?: string;
    managerComments?: string;
    status: LeaveRequestStatus;
    balanceDeducted: number;
    overlapedByBalance: number;
    userId?: string;
    user?: User;
    managerId?: string;
    manager?: User;
    leaveTypeId: number;
    leaveType: LeaveType;
    attachmentRequired: boolean;
    leaveRequestAttachements: LeaveRequestAttachment[];
    overlappedLeaveDay?: OverlappedLeaveDay;
    overlappedByLeaveDay?: OverlappedLeaveDay;
}

// ..\mowazaf\Data\Attendance\Entities\UserLeaveRequest.cs
export enum LeaveRequestStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Cancelled = 'Cancelled',
    CancellationPending = 'CancellationPending',
}

// ..\mowazaf\Data\Attendance\Entities\UserLeaveRequest.cs
export enum HalfDayPart {
    AM = 'AM',
    PM = 'PM',
}

// ..\mowazaf\Data\Attendance\Entities\UserStatus.cs
export enum UserStatus {
    Available = 'Available',
    WorkingHoursNotFulfilled = 'WorkingHoursNotFulfilled',
    Absent = 'Absent',
    Leave = 'Leave',
    SickLeave = 'SickLeave',
    Holiday = 'Holiday',
    Future = 'Future',
    NonWorkingDay = 'Non-Working Day',
    HalfDayLeave = 'HalfDayLeave',
}

// ..\mowazaf\Data\Attendance\Entities\WeekSchedule.cs
export interface WeekSchedule {
    id: number;
    companyId?: number;
    company?: Company;
    userId?: string;
    user?: User;
    weekStartEndHoursAndMinutes?: string;
}

// ..\mowazaf\Data\Attendance\Entities\Workplace.cs
export interface Workplace {
    id: number;
    companyId: number;
    userId?: string;
    bounds?: string;
    company?: Company;
    user?: User;
}

// ..\mowazaf\Data\Attendance\Entities\Workplace.cs
export interface Bound {
    lat: number;
    lng: number;
}

// ..\mowazaf\Data\Attendance\Entities\Workplace.cs
export enum WorkplaceConfig {
    CompanyOrUserSpecific = 'CompanyOrUserSpecific',
    AnyLocation = 'AnyLocation',
    // User-level only: inherit enforcement from the company default.
    InheritedFromCompany = 'InheritedFromCompany',
}

// ..\mowazaf\Data\Attendance\Entities\Workplace.cs
// What happens when an enforced employee clocks OUTSIDE all allowed bounds.
export enum OutOfBoundsPolicy {
    Block = 'Block',
    AllowWithReason = 'AllowWithReason',
    RequireApproval = 'RequireApproval',
}

// ..\mowazaf\Data\Attendance\Entities\Workplace.cs
// Per-clock-side review state for an out-of-bounds punch under the RequireApproval policy.
export enum LocationApprovalStatus {
    NotRequired = 'NotRequired',
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
}

// ..\mowazaf\Data\Attendance\Entities\Workplace.cs
// How to treat a clock with no location fix.
export enum NoLocationPolicy {
    Allow = 'Allow',
    Block = 'Block',
    AllowWithReason = 'AllowWithReason',
}

// ..\mowazaf\Data\Attendance\View Models\EffectiveClockingConfigView.cs
// Read-only, caller-scoped snapshot of the geofence/out-of-bounds clocking config that applies to the
// requesting user (their per-user WorkplaceConfig resolved against the company default), plus the
// reason presets and the polygons they clock against. Lets the client pre-detect an out-of-bounds
// clock and reveal the reason field before the first submit — the server still enforces the policy.
export interface EffectiveClockingConfigView {
    enforced: boolean;
    workplaceConfig: WorkplaceConfig;
    outOfBoundsPolicy: OutOfBoundsPolicy;
    noLocationPolicy: NoLocationPolicy;
    workplaceBufferMeters: number;
    // Effective reason presets: the company's configured list, else the shared default. Never null.
    reasonPresets: string[];
    // The polygons this caller clocks against (their user-specific workplaces + company-wide ones).
    workplaces: WorkplaceModel[];
}

// ..\mowazaf\Data\Attendance\Input Models\AllowedLeaveInput.cs
export interface AllowedLeaveInput {
    leaveTypeId: number;
    userId: string;
    allowedCount: number;
}

// ..\mowazaf\Data\Attendance\Input Models\BreakInInput.cs
export interface BreakInInput {
    breakInTime: Date;
    breakInTimeUtc: Date;
    breakInLatitude?: number;
    breakInLongitude?: number;
    breakInClientType: ClientType;
    breakInAddress: string;
    breakInCountry: string;
    breakInComments: string;
    breakInImageUrl: string;
}

// ..\mowazaf\Data\Attendance\Input Models\BreakInput.cs
export interface BreakInput {
    shiftId: number;
    breakInTime: Date;
    breakInTimeUtc: Date;
    breakInLatitude?: number;
    breakInLongitude?: number;
    breakInClientType: ClientType;
    breakInComments: string;
    breakInImageUrl: string;
    breakInAddress: string;
    breakInCountry: string;
    breakOutTime?: Date;
    breakOutTimeUtc?: Date;
    breakOutLatitude?: number;
    breakOutLongitude?: number;
    breakOutClientType: ClientType;
}

// ..\mowazaf\Data\Attendance\Input Models\BreakOutInput.cs
export interface BreakOutInput {
    breakOutTime?: Date;
    breakOutTimeUtc?: Date;
    breakOutLatitude?: number;
    breakOutLongitude?: number;
    breakOutClientType: ClientType;
    breakOutComments?: string;
    breakOutImageUrl?: string;
    breakOutAddress?: string;
    breakOutCountry?: string;
}

// ..\mowazaf\Data\Attendance\Input Models\ClockingInput.cs
export interface ClockingInput {
    latitude?: number;
    longitude?: number;
    fullAddress?: string;
    time: Date;
    hoursOffset: number;
    userId?: string;
    comments?: string;
    clientType: ClientType;
    image?: File | null;
    projectId?: number;
    workItemId?: number;
    isManualEntry?: boolean;
    // Justification when clocking outside the allowed bounds (or with no location fix) under a
    // permissive company policy. Required by the server; ignored when in-bounds.
    outOfBoundsReason?: string;
}

// ..\mowazaf\Data\Attendance\Input Models\ClockingPaginationInput.cs
export interface ClockingPaginationInput {
    from: Date;
    to: Date;
}

// ..\mowazaf\Data\Attendance\Input Models\ClockingsReportInput.cs
// MAC-A — `from`/`to`: the report tab sends plain `yyyy-MM-dd` day keys (the server takes `.Date`,
// `to` inclusive). A `Date` is still accepted for the legacy callers, but it is serialised as a UTC
// instant whose calendar day depends on the browser zone — see views/Attendance/Reports/reportPeriod.ts.
export interface ClockingsReportInput {
    userId?: string;
    from: Date | string;
    to: Date | string;
    userIds?: string[];
    departmentIds?: number[];
    countryIds?: number[];
    branchIds?: number[];
    searchMethod?: string;
}

// ..\mowazaf\Data\Attendance\Input Models\ClockInInput.cs
export interface ClockInInput {
    clockInTime: Date;
    clockInTimeUtc: Date;
    clockInLongitude?: number;
    clockInLatitude?: number;
    clockInClientType: ClientType;
    clockInComments: string;
    clockInAddress: string;
    clockInCountry: string;
    clockInImageUrl: string;
}

// ..\mowazaf\Data\Attendance\Input Models\ClockOutInput.cs
export interface ClockOutInput {
    clockOutTime?: Date;
    clockOutTimeUtc?: Date;
    clockOutLongitude?: number;
    clockOutLatitude?: number;
    clockOutClientType: ClientType;
    clockOutComments: string;
    clockOutImageUrl: string;
    clockOutAddress: string;
    clockOutCountry: string;
}

// ..\mowazaf\Data\Attendance\Input Models\EarlyClockOutNotificationTemplateModel.cs
export interface EarlyClockOutNotificationTemplateModel {
    timesheetUrl: string;
    userId: string;
    email: string;
    fullName: string;
    date: string;
    time: string;
}

// ..\mowazaf\Data\Attendance\Input Models\EditClockingInput.cs
export interface EditClockingInput {
    latitude?: number;
    longitude?: number;
    fullAddress?: string;
    time?: string;
    userId?: string;
    comments?: string;
    clientType?: ClientType;
    image?: File | null;
    type?: ClockingType;
}

// ..\mowazaf\Data\Attendance\Input Models\LabeledFaceDescriptorsInput.cs
export interface LabeledFaceDescriptorsInput {
    labeledFaceDescriptors: string;
    imageId: number;
}

// ..\mowazaf\Data\Attendance\Input Models\LeaveAttachmentsInput.cs
export interface LeaveAttachmentsInput {
    leaveRequestId: number;
    attachments: File[];
}

// ..\mowazaf\Data\Attendance\Input Models\LeaveConfigInput.cs
/** @deprecated Row shape of the legacy `Leave/UpdateLeavesConfig` batch. Deleted in release N+1;
 *  use `CompanyLeaveRuleInput` / `CompanyLeaveRuleView` instead. */
export interface LeaveConfigInput {
    id: number;
    enabled: boolean;
    eligibility: number;
    quotaUnit: QuotaUnit;
    balance: number;
    quotaType: QuotaType;
    isCummulative: boolean;
    annuallyResets: boolean;
    includeNonWorkingrDays: boolean;
    leaveOverlapsOtherLeaves: boolean;
    inheritedFromCompany: boolean;
    leaveTypeId: number;
    attachmentRequired: boolean;
    warningThreshold?: number | null;
    leaveType?: LeaveType;
    companyId: number;
    company?: Company;
    userId?: string;
    user?: User;
    countryId: number;
    country?: Country;
}

// ..\mowazaf\Data\Attendance\Input Models\CompanyLeaveRulesInput.cs
/**
 * Batch upsert body for `PUT Leave/Policies/Company/{companyId}/LeaveTypeRules`.
 * See docs/leave-policies/SPEC-operator-cross-tenant-policies.md §3.3.
 */
export interface CompanyLeaveRulesInput {
    rows: CompanyLeaveRuleInput[];
}

/**
 * Deliberately carries NO `companyId` and NO `id`: the route is the only authority for the tenant
 * and `(leaveTypeId, countryId)` is the natural key. That removes by construction the two bug
 * classes the legacy `LeaveConfigInput` batch had to guard against — a row carrying a foreign
 * company id, and a lookup keyed on an id the GET hands back as 0.
 */
export interface CompanyLeaveRuleInput {
    leaveTypeId: number;
    countryId: number;
    enabled: boolean;
    eligibility: number;
    quotaType: QuotaType;
    quotaUnit: QuotaUnit;
    isCummulative: boolean;
    annuallyResets: boolean;
    includeNonWorkingrDays: boolean;
    leaveOverlapsOtherLeaves: boolean;
    attachmentRequired: boolean;
    warningThreshold?: number | null;
}

// ..\mowazaf\Data\Attendance\Input Models\LeaveRequestApprovalInput.cs
export interface LeaveRequestApprovalInput {
    id: number;
    isApproved: boolean;
    managerComment?: string;
}

// ..\mowazaf\Data\Attendance\Input Models\LeaveRequestInput.cs
export interface LeaveRequestInput {
    leaveTypeId: number;
    userId: string;
    startDate: string;
    fromHalfDay: boolean;
    fromHalfDayPart: HalfDayPart;
    endDate: string;
    toHalfDay: boolean;
    toHalfDayPart: HalfDayPart;
    comments?: string;
    hasAttachments?: boolean;
}

// ..\mowazaf\Data\Attendance\Input Models\LeaveRequestResponseTemplateModel.cs
export interface LeaveRequestResponseTemplateModel {
    baseUrl: string;
    userId: string;
    email: string;
    leaveType: string;
    comment: string;
    fromDate: string;
    toDate: string;
    fullName: string;
    response: string;
    managerFullName: string;
    managerComment: string;
}

// ..\mowazaf\Data\Attendance\Input Models\LeaveRequestTemplateModel.cs
export interface LeaveRequestTemplateModel {
    baseUrl: string;
    userId: string;
    email: string;
    leaveType: string;
    comment: string;
    fromDate: string;
    fromHalfDay: boolean;
    fromHalfDayPart: string;
    toDate: string;
    toHalfDay: boolean;
    toHalfDayPart: string;
    fullName: string;
}

// ..\mowazaf\Data\Attendance\Input Models\LeavesBalanceReportInput.cs
/** Which requests the balance report's `leavesRequested` figure counts. Server default is
 *  `ApprovedPending` — the field is bound by NAME, so these strings must match the C# enum. */
export type LeavesRequestedMode = 'ApprovedPending' | 'All';

export interface LeavesBalanceReportInput {
    userId: string;
    userIds: string[];
    leaveTypeIds: number[];
    showManager: boolean;
    mergeManagerCells: boolean;
    requestedMode: LeavesRequestedMode;
}

// ..\mowazaf\Data\Attendance\Input Models\LeavesConfigInput.cs
/** @deprecated Body of the legacy `Leave/UpdateLeavesConfig`. Deleted in release N+1;
 *  use `CompanyLeaveRulesInput` instead. */
export interface LeavesConfigInput {
    companyId: number;
    userId?: string;
    leaveConfigInputList: LeaveConfigInput[];
}

// ..\mowazaf\Data\Attendance\Input Models\LeavesReportInput.cs
// MAC-A — `from`/`to`: the report tab sends ZONE-LESS wall-clock bounds (`2026-10-12T00:00:00` ..
// `2026-10-13T23:59:59`), compared as written with the leave's calendar dates. A `Date` is still
// accepted for the legacy callers — see views/Attendance/Reports/reportPeriod.ts for why not to.
export interface LeavesReportInput {
    userId: string;
    from: Date | string;
    to: Date | string;
    userIds?: string[];
    departmentIds?: number[];
    countryIds?: number[];
    branchIds?: number[];
    searchMethod: string;
}

// ..\mowazaf\Data\Attendance\Input Models\OvertimeApprovalRequestTemplateModel.cs
export interface OvertimeApprovalRequestTemplateModel {
    url: string;
    userId: string;
    email: string;
    fullName: string;
    date: string;
    time: string;
}

// ..\mowazaf\Data\Attendance\Input Models\OvertimeApprovalResponseTemplateModel.cs
export interface OvertimeApprovalResponseTemplateModel {
    url: string;
    userId: string;
    email: string;
    fullName: string;
    date: string;
    time: string;
    response: string;
    managerFullName: string;
    managerComment: string;
}

// ..\mowazaf\Data\Attendance\Input Models\OvertimeReportInput.cs
// Deliberately NARROWER than ShiftsReportInput: the Overtime endpoint takes users + a date range and
// nothing else (no department/branch/country/searchMethod), so the tab must not offer those filters.
// CO-299 — userIds is OPTIONAL, matching the server (`List<string> UserIds { get; set; } = new()`):
// omitting it (or sending an empty list, which object-to-formdata drops entirely) makes the
// controller expand it to every user the caller may see — Hr/Chief the company, Manager their team,
// everyone else themselves. The deep-link export component still passes a LeavesReportInput here,
// which only stays assignable while this stays optional.
// MAC-A — `from`/`to`: the report tab sends plain `yyyy-MM-dd` day keys; the server walks
// `From.Date .. To.Date` INCLUSIVE and resolves each day in the EMPLOYEE's time zone. A `Date` is
// still accepted for the legacy callers — see views/Attendance/Reports/reportPeriod.ts for why not to.
export interface OvertimeReportInput {
    userId: string;
    from: Date | string;
    to: Date | string;
    userIds?: string[];
}

// ..\mowazaf\Data\Attendance\Input Models\OvertimeShiftApprovalInput.cs
export interface OvertimeShiftApprovalInput {
    shiftId: number;
    isApproved: boolean;
    /**
     * 🔴 CO-307 — REVERSING a decision that is already on record, as opposed to making one.
     *
     * The server refuses a second decision on a decided shift with 409 (AttendanceService
     * .OvertimeShiftApproval), deliberately: two reviewers hold the same report open and a silent
     * overwrite would change a wage from a stale screen. A reversal is the SAME write with the
     * reviewer having seen the recorded decision first, so it travels as an explicit flag rather
     * than as a second, divergent endpoint — the shape `ReverseTerminationInput
     * .AllowPaidSettlementReversal` already established in this codebase.
     *
     * ⚠️ SENT ONLY from the explicit "change this decision" affordance, NEVER from the ordinary
     * approve/reject path. That asymmetry is load-bearing: a day can mix decided and undecided
     * shifts, and the ordinary path posts every contributing shift id, so without the flag the
     * server's 409 is what protects the already-decided ones from being silently re-written by a
     * reviewer who only meant to decide the remainder.
     *
     * Optional because it is additive in BOTH directions (expand/contract rule 5): the server also
     * accepts it as a `?overrideDecision=` query parameter and ORs the two, an old client that omits
     * it gets exactly the previous behaviour, and an old BACKEND under this bundle simply ignores the
     * body field and answers 409 — which the tab renders with the server's own sentence rather than
     * as a generic failure.
     */
    overridePreviousDecision?: boolean;
}

// ..\mowazaf\Data\Attendance\Input Models\ReportCreationTemplateModel.cs
export interface ReportCreationTemplateModel {
    baseUrl: string;
    startDate: string;
    endDate: string;
    reportName: string;
    companyName: string;
}

// ..\mowazaf\Data\Attendance\Input Models\ScheduledShiftInput.cs
export interface ScheduledShiftInput {
    id: number;
    startTime: string;
    endTime: string;
    userId: string;
    overrideReason?: string; // Optional reason for manual override
}

// ..\mowazaf\Data\Attendance\Input Models\ShiftInput.cs
export interface ShiftInput {
    clockInTime: Date;
    clockInTimeUtc: Date;
    clockInLongitude?: number;
    clockInLatitude?: number;
    clockInClientType: ClientType;
    clockInImageUrl?: string;
    clockInAddress: string;
    clockInCountry: string;
    clockOutTime?: Date;
    clockOutTimeUtc?: Date;
    clockOutLongitude?: number;
    clockOutLatitude?: number;
    clockOutClientType: ClientType;
    clockOutImageUrl?: string;
    clockOutAddress: string;
    clockOutCountry: string;
    clockInComments?: string;
    clockOutComments?: string;
    userId?: string;
}

// ..\mowazaf\Data\Attendance\Input Models\ShiftsReportInput.cs
// MAC-A — `from`/`to` mean two different things on this endpoint, decided by whether the value
// carries a zone: ZONE-LESS (`2026-10-12T00:00:00`, what the report tab sends) = wall-clock bounds
// matched on the employee's own clock (ClockInTime / ClockOutTime); a `Date` or a `…Z` string = a UTC
// INSTANT window matched on the Utc columns (the legacy deep-link export). See
// ReportsService.GetShiftsPerUserAsync and views/Attendance/Reports/reportPeriod.ts.
export interface ShiftsReportInput {
    userId: string;
    from: Date | string;
    to: Date | string;
    userIds?: string[];
    hideBreaks: boolean;
    departmentIds?: number[];
    countryIds?: number[];
    branchIds?: number[];
    searchMethod: string;
}

// ..\mowazaf\Data\Attendance\Input Models\OutOfBoundsReportInput.cs
// HR analytics of out-of-bounds clocks. Mirrors ShiftsReportInput (minus hideBreaks) so the Reports UI
// reuses the same user/department/branch/country filter machinery.
export interface OutOfBoundsReportInput {
    userId: string;
    from: Date;
    to: Date;
    userIds?: string[];
    departmentIds?: number[];
    countryIds?: number[];
    branchIds?: number[];
    searchMethod: string;
}

// ..\mowazaf\Data\Attendance\View Models\OutOfBoundsClockView.cs
// One row per breached clock side (a shift out-of-bounds on both clock-in and clock-out yields two
// rows). Powers the HR "out-of-bounds clocks" analytics report. clockType and locationApprovalStatus
// arrive as their string enum names.
export interface OutOfBoundsClockView {
    userId?: string;
    userFullName?: string;
    shiftId: number;
    clockType: ClockingType;
    // UTC timestamp of the breached clock (clock-in or clock-out time).
    timeUtc: string;
    // How far outside the bounds the clock was, in metres (null when unknown).
    distanceMeters?: number | null;
    // Employee-supplied justification captured at clock time.
    reason?: string | null;
    // Reverse-geocoded address of the breached clock.
    address?: string | null;
    // Approval state for the breached side (NotRequired / Pending / Approved / Rejected).
    locationApprovalStatus: LocationApprovalStatus;
}

// ..\mowazaf\Data\Attendance\Input Models\UpdateCustomStatusInput.cs
export interface UpdateCustomStatusInput {
    currentCustomStatus: string;
}

// ..\mowazaf\Data\Attendance\Input Models\UsersMissedClockInNotificationTemplateModel.cs
export interface UsersMissedClockInNotificationTemplateModel {
    userMissedClockInListItems: UserMissedClockInListItem[];
}

// ..\mowazaf\Data\Attendance\Input Models\UsersMissedClockInNotificationTemplateModel.cs
export interface UserMissedClockInListItem {
    userFullName: string;
    timesheetLink: string;
}

// ..\mowazaf\Data\Attendance\Input Models\UsersStatusesReportInput.cs
export interface UsersStatusesReportInput {
    userId: string;
    from: Date;
    to: Date;
    userIds?: string[];
    departmentIds?: number[];
    countryIds?: number[];
    branchIds?: number[];
    searchMethod: string;

    // Optional server-side sorting (Team Attendance)
    sortBy?: 'date' | 'employee' | 'clockIn' | 'clockOut' | 'totalHours' | 'status' | string;
    sortDirection?: 'asc' | 'desc' | string;

    // Pagination (pageSize <= 0 means "return all")
    pageNumber?: number;
    pageSize?: number;

    // Server-side status filter — UserStatus enum names e.g. ["Available","Absent"]
    statuses?: string[];

    // When false (default), rows with NonWorkingDay status and no clocking are excluded
    includeEmptyNonWorkingDays?: boolean;
}

// ..\mowazaf\Data\Attendance\Input Models\WeekScheduleInput.cs
export interface WeekScheduleInput {
    id: number;
    companyId?: number;
    userId?: string;
    weekStartEndHoursAndMinutes: number[][];
}

// ..\mowazaf\Data\Attendance\View Models\AutoBreakOutView.cs
export interface AutoBreakOutView {
    userId: string;
    shiftId: number;
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    baseUrl: string;
    timezoneId: string;
}

// ..\mowazaf\Data\Attendance\View Models\BreakView.cs
export interface BreakView {
    id: number;
    shiftId: number;
    shift: Shift;
    breakInTime: Date;
    breakInTimeUtc: Date;
    breakInLatitude?: number;
    breakInLongitude?: number;
    breakInClientType: ClientType;
    breakInImageUrl?: string;
    breakInComments?: string;
    breakInAddress?: string;
    breakInCountry?: string;
    breakOutTime?: Date;
    breakOutTimeUtc?: Date;
    breakOutLatitude?: number;
    breakOutLongitude?: number;
    breakOutClientType: ClientType;
    breakOutImageUrl?: string;
    breakOutComments?: string;
    breakOutAddress?: string;
    breakOutCountry?: string;
    createdOn: Date;
    updatedOn?: Date;
    createdById?: string;
    updatedById?: string;
    isArchived: boolean;
    isEdited: boolean;
    hasEnded: boolean;
    duration: string;
}

// ..\mowazaf\Data\Attendance\View Models\ClockingNotificationView.cs
export interface ClockingNotificationView {
    userId: string;
    companyId: number;
    countryId: number;
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    baseUrl: string;
    timezoneId: string;
    type: ClockingType;
    toHalfDay: boolean;
}

// ..\mowazaf\Data\Attendance\View Models\ClockingPaginationView.cs
export interface ClockingPaginationView {
    from: Date;
    to: Date;
    results: DaySummaryView[];
    totalWorkTime: string;
}

// ..\mowazaf\Data\Attendance\View Models\ClockingsPerUserPerDayView.cs
export interface ClockingsPerUserPerDayView {
    id: number;
    time: Date;
    timeUtc: Date;
    userId: string;
    userFullName: string;
    type: ClockingType;
    comments: string;
    latitude?: number;
    longitude?: number;
    createdOn: Date;
    updatedOn?: Date;
    createdById: string;
    updatedById: string;
    isArchived: boolean;
    clientType: ClientType;
    address: string;
    imageUrl: string;
    userTitle: string;
}

// ..\mowazaf\Data\Attendance\View Models\ClockingsDailyRowView.cs
/**
 * ONE ROW PER PERSON PER DAY — the shape `/attendance/reports/clockings` was rebuilt around, and the
 * pivot of the per-punch `ClockingsPerUserPerDayView` above (which the mobile report still uses).
 *
 * ⚠️ EVERY TIMESTAMP HERE IS A LOCAL WALL-CLOCK STRING with no offset (`2026-08-05T09:00:00`), in
 * the EMPLOYEE's timezone — the same convention `ShiftReportView.clockInTime` uses. They are typed
 * `string`, not `Date`, precisely so nothing hands them to `new Date()`: that re-interprets them in
 * the READER's timezone, and an HR user in Dubai reading a Cairo employee's 09:00 would see 11:00.
 * Read them textually (see `wallClock()` in the tab).
 */
export interface ClockingPunchView {
    id: number;
    shiftId: number;
    type: ClockingType;
    /** LOCAL wall-clock, no offset. */
    time: string;
    clientType: ClientType;
    address?: string;
    comments?: string;
    latitude?: number;
    longitude?: number;
    imageUrl?: string;
    wasOutOfBounds: boolean;
    outOfBoundsDistanceMeters?: number;
    outOfBoundsReason?: string;
}

export interface ClockingsDailyRowView {
    userId: string;
    userFullName: string;
    userTitle?: string;
    departmentName?: string;
    branchName?: string;
    /** The LOCAL calendar day, at midnight. */
    date: string;
    /** Null when NO scheduled occurrence covered the day — not the same fact as a zero-length schedule. */
    scheduledStart?: string;
    scheduledEnd?: string;
    /** .NET TimeSpan (`hh:mm:ss`). */
    scheduledDuration?: string;
    firstIn?: string;
    /** Null when every shift on the day is still open. */
    lastOut?: string;
    shiftCount: number;
    punchCount: number;
    breakCount: number;
    breakMinutes: number;
    /** Closed shifts only: an open shift contributes zero, never `now − clockIn`. */
    workedMinutes: number;
    inClientType?: ClientType;
    outClientType?: ClientType;
    inAddress?: string;
    outAddress?: string;
    missingOut: boolean;
    outOfBounds: boolean;
    manualEdit: boolean;
    lateIn: boolean;
    lateMinutes: number;
    earlyOut: boolean;
    earlyOutMinutes: number;
    /** `Present` | `Late` | `EarlyLeave` | `Unscheduled` — the Shifts report's vocabulary. */
    dayStatus: string;
    punches: ClockingPunchView[];
}

// ..\mowazaf\Data\Attendance\View Models\GaugeView.cs
// 🔴 FL-88 — the clocking gauge. Its number is a THIRD number: NOT `currentShift.workingDuration`
// (one session, restarts on a second clock-in) and NOT `today.workingTime` (the whole local day).
// It is the total worked time of every session belonging to the scheduled occurrence in effect.
// The server computes all of it; the client never derives geometry or membership from timestamps.
export enum GaugeScope {
    None = 'None',
    Session = 'Session',
    ScheduledOccurrence = 'ScheduledOccurrence',
}

export enum GaugePunchKind {
    ClockIn = 'ClockIn',
    ClockOut = 'ClockOut',
    BreakStart = 'BreakStart',
    BreakEnd = 'BreakEnd',
}

/** One WORKED arc, window-relative and clamped to [0,1]. A session with a break yields TWO. */
export interface GaugeSegment {
    start: number;
    end: number;
    /** Still running — this is the only segment a client may tick. */
    isOpen: boolean;
}

export interface GaugePunch {
    /** UTC instant, serialized with an explicit `Z`. */
    atUtc: string;
    kind: GaugePunchKind;
    /**
     * 🔴 The company zone's UTC offset AT THIS INSTANT, minutes. Render `atUtc + offsetMinutes` as a
     * WALL CLOCK — never `toLocaleTimeString` in the viewer's zone, never `Intl` with a timezone id.
     * Web and mobile must do the same arithmetic so they print the same string; the offset is per
     * punch so an overnight shift crossing a DST transition renders both halves correctly.
     */
    offsetMinutes: number;
}

export interface GaugeView {
    scope: GaugeScope;
    /** TimeSpan string ("06:30:00"). THE NUMBER, uncapped — overtime climbs past the window. */
    workedDuration: string;
    breaksDuration: string;
    /** Window length in seconds; 28800 (8 h) when there is no scheduled occurrence. Never 0. */
    ringDenominatorSeconds: number;
    segments: GaugeSegment[];
    punches: GaugePunch[];
    /** IANA id — a DISPLAY CAPTION only ("times shown in Asia/Dubai"). Never compute with it. */
    timeZoneId: string;
    windowStartUtc?: string;
    windowEndUtc?: string;
    windowStartOffsetMinutes?: number;
    windowEndOffsetMinutes?: number;
    firstClockInUtc?: string;
    /** 🔴 Never key on this: 0 means a VIRTUAL occurrence and many distinct ones report 0. */
    scheduledShiftId?: number;
    sessionCount: number;
    hasOpenSession: boolean;
    isOnBreak: boolean;
    isPastWindowEnd: boolean;
    isCompleted: boolean;
    asOfUtc: string;
}

// ..\mowazaf\Data\Attendance\View Models\ClockingStatusView.cs
export interface ClockingStatusView {
    allowedActions: ClockingType[];
    currentShift: ShiftView;
    /** 🔴 FL-88 — always present, even with no open session (which is why it is not on ShiftView). */
    gauge: GaugeView;
}

// ..\mowazaf\Data\Attendance\View Models\ClockingView.cs
export interface ClockingView {
    id: number;
    time: Date;
    timeUtc: Date;
    userId: string;
    type: ClockingType;
    comments?: string;
    latitude?: number;
    longitude?: number;
    createdOn: Date;
    updatedOn?: Date;
    createdById?: string;
    updatedById?: string;
    isArchived: boolean;
    clientType: ClientType;
    address?: string;
    imageUrl?: string;
    isEdited: boolean;
}

// ..\mowazaf\Data\Attendance\View Models\CompanyLeaveView.cs
export interface CompanyLeaveView {
    id: number;
    eligibility: number;
    quotaUnit: QuotaUnit;
    quotaType: QuotaType;
    isCummulative: boolean;
    annuallyResets: boolean;
    includeNonWorkingrDays: boolean;
    leaveOverlapsOtherLeaves: boolean;
    leaveTypeId: number;
    attachmentRequired: boolean;
    leaveType?: LeaveType;
    companyId: number;
    countryId: number;
}

// ..\mowazaf\Data\Attendance\View Models\DaySummaryView.cs
export interface DaySummaryView {
    shifts: ShiftView[];
    sessions: WorkSessionView[];
    workingTime: string;
    breaksTime: string;
    dayStatus: DayStatus;
    scheduledShifts: ScheduledShiftView[];
}

// ..\mowazaf\Data\Attendance\View Models\EndShiftView.cs
export interface EndShiftView {
    userId: string;
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    baseUrl: string;
    timezoneId: string;
}

// ..\mowazaf\Data\Attendance\View Models\FaceRecognitionEmail.cs
export interface FaceRecognitionEmail {
    username: string;
}

// ..\mowazaf\Data\Attendance\View Models\FaceRecognitionResultView.cs
export interface FaceRecognitionResultView {
    status: number;
    payload: boolean;
    message: string;
}

// ..\mowazaf\Data\Attendance\View Models\GenericRequestsView.cs
export interface GenericRequestsView {
    list: GenericRequestView[];
}

// ..\mowazaf\Data\Attendance\View Models\GenericRequestView.cs
export interface GenericRequestView {
    requestType: GenericRequestType;
    user: UserViewSimple;
    id: number;
    userId: string;
    leaveType: string;
    startDate: Date;
    fromHalfDay?: boolean;
    endDate: Date;
    toHalfDay?: boolean;
    lastUpdate: Date;
    status: LeaveRequestStatus;
    comments: string;
    managerName: string;
    managerComments: string;
    quotaUnit: QuotaUnit;
    attachmentCount: number;
    attachmentRequired: boolean;
    numberOfDays: number;
}

// ..\mowazaf\Data\Attendance\View Models\GenericRequestView.cs
export enum GenericRequestType {
    LeaveRequest = 'LeaveRequest',
}

// ..\mowazaf\Data\Attendance\View Models\InBreakVerificationView.cs
export interface InBreakVerificationView {
    userId: string;
    shiftId: number;
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    baseUrl: string;
    timezoneId: string;
}

// ..\mowazaf\Data\Attendance\View Models\LeaveBalanceView.cs
export interface LeaveBalanceView {
    leaveTypeId: number;
    leaveType: string;
    eligibility: number;
    quotaUnit: QuotaUnit;
    balance: number;
    used: number;
    includeNonWorkingrDays: boolean;
    warningThreshold?: number | null;
    carryForwardBalance: number;
    carryForwardExpiry?: string | null;
    accrualFrequency?: string | null;
    accrualRate?: number | null;
    renewalDate?: string | null;
    minNoticeDays: number;
    maxConsecutiveDays?: number | null;
    sandwichRuleEnabled: boolean;
    payTiers?: PayTierView[];
}

// ..\mowazaf\Data\Attendance\Input Models\BalanceAdjustmentInput.cs
export interface BalanceAdjustmentInput {
    userId: string;
    leaveTypeId: number;
    amount: number;
    reason?: string;
}

// Leave Balances Page
export interface AllBalancesView {
    leaveTypes: LeaveTypeColumnView[];
    employees: PaginatedResult<EmployeeBalanceRow>;
}

export interface LeaveTypeColumnView {
    id: number;
    name: string;
    code?: string;
    color?: string;
}

export interface EmployeeBalanceRow {
    userId: string;
    fullName: string;
    departmentName?: string;
    branchName?: string;
    employmentType?: string;
    balances: Record<number, number>;
}

export interface AllBalancesFilterInput {
    search?: string;
    departmentId?: number;
    branchId?: number;
    employmentType?: string;
    sortBy?: string;
    sortDirection?: 'asc' | 'desc';
    page?: number;
    pageSize?: number;
}

export interface BulkBalanceAdjustInput {
    adjustments: BalanceAdjustItem[];
}

export interface BalanceAdjustItem {
    userId: string;
    leaveTypeId: number;
    newBalance: number;
    reason?: string;
}

export interface BulkAdjustResultView {
    successCount: number;
    failedItems: BulkAdjustFailedItem[];
}

export interface BulkAdjustFailedItem {
    userId: string;
    leaveTypeId: number;
    reason: string;
}

// ..\mowazaf\Data\Attendance\View Models\LeaveRequestAttachmentView.cs
export interface LeaveRequestAttachmentView {
    id: number;
    name: string;
    extention: string;
    byteLength: number;
    path: string;
    createdOn: Date;
    userLeaveRequestId: number;
}

// ..\mowazaf\Data\Attendance\View Models\LeaveRequestsView.cs
export interface LeaveRequestsView {
    isManager: boolean;
    leaveRequests: LeaveRequestView[];
}

// ..\mowazaf\Data\Attendance\View Models\LeaveRequestReviewerView.cs
export interface LeaveRequestReviewerView {
    stepOrder: number;
    reviewerName?: string;
    status?: string;
    actionDate?: string;
    comments?: string;
}

// ..\mowazaf\Data\Attendance\View Models\LeaveRequestView.cs
export interface LeaveRequestView {
    id: number;
    userId: string;
    user: UserViewSimple;
    leaveType: string;
    startDate: Date;
    fromHalfDay?: boolean;
    fromHalfDayPart: HalfDayPart;
    endDate: Date;
    toHalfDay?: boolean;
    toHalfDayPart: HalfDayPart;
    lastUpdate: Date;
    status: LeaveRequestStatus;
    comments: string;
    managerName: string;
    managerComments: string;
    quotaUnit: QuotaUnit;
    attachmentCount: number;
    attachmentRequired: boolean;
    numberOfDays: number;
    isRetroactive: boolean;
    isOnBehalf: boolean;
    submittedByName?: string;
    dateApplied: string;
    userDepartmentName?: string;
    userBranchName?: string;
    userManagerName?: string;
    cancelReason?: string;
    cancelledDate?: string;
    reviewers?: LeaveRequestReviewerView[];
    blackoutWarning?: string;
    blackoutSeverity?: BlackoutSeverity | null;
    warnings?: string[];
    /**
     * CO-346 — may THIS caller decide this request RIGHT NOW? Server-computed from the workflow
     * engine's own write gate (WorkflowEngineService.IsAuthorizedForStepAsync), so the button state
     * and the refusal cannot drift apart. Only the approvals endpoints populate it, so treat
     * `undefined` as "unknown, allow" and gate strictly on `=== false`; the server re-checks on write.
     */
    canDecideNow?: boolean;
    /** CO-346 — who the workflow is waiting on, when it is not this caller. Explanatory only. */
    pendingApproverName?: string;
    /** CO-814 — approved without a human decision (status stays Approved). */
    autoApproved?: boolean;
    /** CO-814 — HR's per-employee approval bypass, or a workflow auto-approval rule. */
    autoApprovalReason?: 'ApprovalBypass' | 'WorkflowAutoApproval' | 'PolicyNoApprovalRequired' | null;
    /** CO-814 — who decided the request (null/absent when auto-approved or still pending). */
    decidedByName?: string | null;
    /**
     * CO-814 — who a still-pending request is waiting on. Populated ONLY on the requester's own list
     * endpoints (null elsewhere). 'Manager' is the normal case; 'Hr' / 'Chief' are fallbacks when the
     * employee has no able manager; 'Unroutable' = nobody can approve until a manager is assigned.
     */
    pendingWith?: 'Manager' | 'Hr' | 'Chief' | 'Unroutable' | null;
}

// ..\mowazaf\Data\Attendance\View Models\LeavesBalanceReportView.cs
export interface LeavesBalanceReportView {
    user: UserView;
    leaveType: string;
    leaveTypeId: number;
    eligibility: number;
    balance: number;
    leavesRequested: number;
    managerUsernames: string[];
}

// ..\mowazaf\Data\Attendance\View Models\LeavesConfigView.cs
/** @deprecated Legacy `Leave/LeavesConfig` / `Leave/UpdateLeavesConfig` pair. Deleted in release N+1;
 *  use `CompanyLeaveRulesView` on the `Leave/Policies/Company/{companyId}/…` routes instead. */
export interface LeavesConfigView {
    leavesConfig: LeaveConfigInput[];
    leaveTypesCount: number;
    countriesCount: number;
}

// ..\mowazaf\Data\Attendance\View Models\CompanyLeaveConfigViews.cs
/**
 * The country axis for `GET Leave/Policies/Company/{companyId}/Countries`.
 *
 * `employeeCount === 0` is NOT a dead end: with `?includeAll=true` the server returns every country
 * so a tenant with no employees yet (or none with a country set) is still configurable. That is the
 * fix for the empty state the legacy page could only apologise for.
 */
export interface LeaveConfigCountryView {
    id: number;
    name: string;
    iso: string;
    employeeCount: number;
    isCompanyCountry: boolean;
    hasRules: boolean;
}

/** One (leave type x country) entitlement rule. `isPersisted === false` = synthesised default, no row yet. */
export interface CompanyLeaveRuleView {
    leaveTypeId: number;
    leaveTypeName: string;
    countryId: number;
    countryName: string;
    countryIso: string;
    enabled: boolean;
    eligibility: number;
    quotaType: QuotaType;
    quotaUnit: QuotaUnit;
    isCummulative: boolean;
    annuallyResets: boolean;
    includeNonWorkingrDays: boolean;
    leaveOverlapsOtherLeaves: boolean;
    attachmentRequired: boolean;
    warningThreshold?: number | null;
    isPersisted: boolean;
}

export interface CompanyLeaveRulesView {
    companyId: number;
    rows: CompanyLeaveRuleView[];
    leaveTypesCount: number;
    countriesCount: number;
}

/** Aggregate counters only — the save touches employee quota rows but never returns their contents. */
export interface CompanyLeaveRulesSaveResultView {
    config: CompanyLeaveRulesView;
    rulesCreated: number;
    rulesUpdated: number;
    rulesUnchanged: number;
    quotaRowsCreated: number;
    quotaRowsUpdated: number;
}

// ..\mowazaf\Data\Attendance\View Models\LeavesReportView.cs
export interface LeavesReportView {
    user: UserView;
    comments: string;
    leaveType: string;
    isApproved: boolean;
    startDate: Date;
    endDate: Date;
    numberOfDays: number;
    manager: UserView;
    managerComments: string;
    attachementsCount: number;
    leaveRequestStatus: LeaveRequestStatus;
    balanceDeducted: number;
    quotaUnit: QuotaUnit;
    leaveTypeId: number;
    status: LeaveRequestStatus;
}

// ..\mowazaf\Data\Attendance\View Models\LeaveTypeView.cs
export interface LeaveTypeView {
    id: number;
    name: string;
    companyId: number;
    code?: string;
    color?: string;
    icon?: string;
    description?: string;
    isActive: boolean;
    quotaUnit: QuotaUnit;
    attachmentRequired: boolean;
    minNoticeDays: number;
    maxConsecutiveDays?: number;
    sandwichRuleEnabled: boolean;
    /** CO-887: who may hold and request this type. */
    eligibleGender?: LeaveGenderEligibility;
}

/** CO-887. Mirrors the server enum LeaveGenderEligibility (serialized as its name). */
export type LeaveGenderEligibility = 'All' | 'Female' | 'Male';

export interface LeaveTypeInput {
    id?: number;
    name: string;
    code?: string;
    color?: string;
    icon?: string;
    description?: string;
    isActive: boolean;
    minNoticeDays?: number;
    maxConsecutiveDays?: number;
    sandwichRuleEnabled?: boolean;
    /** CO-887: omitted on create = the server defaults it from the name (Maternity = Female, Paternity = Male). */
    eligibleGender?: LeaveGenderEligibility;
}

// ..\mowazaf\Data\Attendance\View Models\OvertimeReportView.cs
export interface OvertimeReportView {
    user: UserView;
    date: Date;
    regularOvertimeHours: number;
    premiumOvertimeHours: number;
    // CO-280: approvedOvertimeHours now really means "approved". Everything not decided on is in
    // unreviewedOvertimeHours; the two together equal regular + premium.
    approvedOvertimeHours: number;
    approvedRegularOvertimeHours: number;
    approvedPremiumOvertimeHours: number;
    unreviewedOvertimeHours: number;
    managerNames: string[];
    // CO-304 — what makes a row ACTIONABLE. Without a shift identity the only decision endpoint
    // (POST attendance/OvertimeShiftApproval, which takes a shiftId) could not be called from this
    // report at all, so the whole approve/reject surface was blocked client-side.
    // 🔴 BOTH ARE OPTIONAL ON PURPOSE. The server field ships in the same wave as this screen, and
    // the SPA back-compat rule (CLAUDE.md, zero-downtime §5) says a browser tab holding the OLD
    // bundle must keep working against the NEW backend AND vice-versa for one rollback window. A
    // required field here would make every row `shiftId: undefined` at runtime while type-checking
    // as `number`, i.e. exactly the silent breakage the rule exists to prevent. The tab therefore
    // treats an absent shiftId as "not actionable" and still renders the hours.
    // ⚠️ A row is one (user, DAY) and a day can aggregate SEVERAL shifts, so the server ships BOTH
    // shapes (OvertimeReportView.cs): `shiftId` is the single contributing shift when there is
    // exactly one and 0 otherwise, `shiftIds` is the authoritative list and is always populated.
    // The tab decides on `shiftIds` — reading `shiftId` alone would leave every multi-shift day
    // undecidable, which is the very hole CO-304 exists to close.
    shiftId?: number;
    shiftIds?: number[];
    // Undecided has TWO shapes and they are not the same fact: `Pending` = a request was raised and
    // nobody answered; `NotRequired` = no request was ever raised (the rest-day / manual-entry holes).
    // `Rejected` MUST stay visually distinct from both — conflating "nobody looked" with "refused"
    // in the reviewer's head is the bug this screen exists to prevent.
    overtimeApprovalStatus?: LocationApprovalStatus;
    // 🔴 CO-306 — REFUSED hours, and the reason the two totals above stopped meaning the same thing.
    // regularOvertimeHours / premiumOvertimeHours are the MONEY carriers and now hold PAYABLE hours:
    // the server subtracts rejected hours from them unconditionally, independently of the per-tenant
    // approval gate. The refused hours are not lost, they move here — display-only, never paid. So:
    //     payable                = regularOvertimeHours + premiumOvertimeHours
    //                            = approvedOvertimeHours + unreviewedOvertimeHours
    //     worked outside schedule = payable + rejectedOvertimeHours
    // Anything that renders "hours worked" MUST add this field back in, or a rejected day reads as
    // if the employee never worked it.
    // Optional for the same back-compat reason as shiftIds above: an older backend omits them, in
    // which case zero is the right reading (that server had no rejected bucket to report).
    rejectedOvertimeHours?: number;
    rejectedRegularOvertimeHours?: number;
    rejectedPremiumOvertimeHours?: number;
    // 🔴 CO-307 — THE PER-SHIFT TRUTH BEHIND A (user, DAY) ROW, mirroring OvertimeReportView.cs.
    //   isPartiallyDecided — the contributing shifts do NOT all share one status, so the row-level
    //     `overtimeApprovalStatus` above is a SUMMARY and not the state of every shift. ⚠️ Read it
    //     narrowly: it is also true for the routine Pending + NotRequired day where NOTHING has been
    //     decided. "How much is still open" comes from undecidedShiftIds, never from this flag.
    //   shiftDecisions — the per-shift breakdown. Emitted for every row, one element on a
    //     single-shift day, so a consumer never needs two code paths.
    //   undecidedShiftIds — the subset a NEW decision applies to (Pending + NotRequired). Deciding a
    //     day means posting these ids and only these: sending the whole of shiftIds would ask the
    //     server to re-open decisions somebody else already made.
    // All optional for the SPA back-compat rule: an older backend omits them and the tab falls back
    // to the hour buckets, which every server in the rollback window does ship.
    isPartiallyDecided?: boolean;
    shiftDecisions?: OvertimeShiftDecisionView[];
    undecidedShiftIds?: number[];
    // 🔴 CO-310 — WHO SIGNED FOR THESE HOURS, AND WHEN. These ARE shipped by the server now
    // (OvertimeReportView.cs projects them in ReportsService.GetOvertimeHoursAsync); the note that
    // used to sit here saying they were not is stale and was removed with the change.
    // ⚠️ A row is one (user, DAY) and a day can aggregate SEVERAL shifts decided by DIFFERENT
    // people, so the row-level pair is deliberately conservative:
    //   decidedByName       — present ONLY when every DECIDED contributing shift was decided by the
    //                         SAME person. Absent when the day is undecided AND when the deciders
    //                         disagree — the server never picks one of several to speak for the day.
    //   hasMultipleDeciders — true when the decided shifts carry more than one distinct decider. The
    //                         screen then says "several reviewers" instead of naming one; the
    //                         per-shift truth is on OvertimeShiftDecisionView below.
    //   decidedOnUtc        — the MOST RECENT decision instant on the day. A true UTC instant with a
    //                         trailing 'Z' (the server forces Kind=Utc), so `new Date(...)` is safe.
    // Still OPTIONAL for the SPA back-compat rule: a bundle running against the previous backend gets
    // nothing here, and rendering NOTHING is the honest degradation — never populate them from any
    // other source client-side.
    decidedByName?: string;
    hasMultipleDeciders?: boolean;
    decidedOnUtc?: string | Date;
}

// ..\mowazaf\Data\Attendance\View Models\OvertimeReportView.cs (OvertimeShiftDecisionView)
// One contributing shift of an overtime report row.
export interface OvertimeShiftDecisionView {
    shiftId: number;
    overtimeApprovalStatus: LocationApprovalStatus;
    /**
     * Hours THIS shift contributed to THIS day, worked outside the schedule and before the
     * approve/reject split. A shift crossing midnight appears on both days with its own clipped
     * share, so this is per (shift, day) and never the whole shift.
     */
    overtimeHours: number;
    clockInTimeUtc: Date | string;
    clockOutTimeUtc?: Date | string | null;
    /**
     * 🔴 CO-310 — the per-shift attribution, which is the only place a MIXED day's truth fits.
     * Both are absent on an undecided shift and on a decision recorded before the shift carried a
     * decider id (the honest reading is "nobody knows", not a blank guess). `decidedOnUtc` is a true
     * UTC instant with a trailing 'Z'.
     */
    decidedByName?: string;
    decidedOnUtc?: string | Date;
}

// ..\mowazaf\Data\Attendance\View Models\OvertimeVerificationView.cs
export interface OvertimeVerificationView {
    userId: string;
    shiftId: number;
    email: string;
    fullName: string;
    firstName: string;
    lastName: string;
    baseUrl: string;
    timezoneId: string;
}

// ..\mowazaf\Data\Attendance\View Models\ReportSchedulerView.cs
export interface ReportSchedulerView {
    companyId: number;
    reportName: string;
    subject: string;
    template: string;
    model: ReportCreationTemplateModel;
    fromDate: Date;
    toDate: Date;
    usersTo: string;
    usersCc: string;
    timezoneId: string;
}

// ..\mowazaf\Data\Attendance\View Models\RequestModel.cs
export interface RequestModel {
    id: number;
    title: string;
    description: string;
    status: string;
    statusId: number;
    priority: string;
    priorityId?: number;
    createdDate: Date;
    expectedDate: Date;
    closedDate: Date;
    assignedUsers: string[];
}

// ..\mowazaf\Data\Attendance\View Models\ScheduledShiftView.cs
export interface ScheduledShiftView {
    id: number;
    startTime: Date;
    endTime: Date;
    userId: string;
    breakStartTime?: Date;
    breakEndTime?: Date;
    breakDurationMinutes?: number | null;
    localBreakStartTime?: Date;
    localBreakEndTime?: Date;
    shiftSetName?: string;
    ruleName?: string;
    // Refactor additions: origin transparency for unified scheduling
    recurringShiftRuleId?: number;
    shiftSetId?: number;
    /** Origin discriminator from server: Rule | ShiftSetEmbedded | ManualOverride */
    origin?: string;
    /** Virtual occurrences are generated on-demand and have id = 0 */
    isVirtual?: boolean;
}

// ..\mowazaf\Data\Attendance\View Models\ShiftHistoryView.cs
export interface ShiftHistoryView {
    id: number;
    shiftId?: number;
    breakId?: number;
    shiftUserId: string;
    updatedById: string;
    updatedByFullName: string;
    clockingType: ClockingType;
    oldClockTime: Date;
    newClockTime: Date;
}

// ..\mowazaf\Data\Attendance\View Models\ShiftReportView.cs
/**
 * The SLIM user the shifts report ships — NOT the full `User`.
 *
 * Mirrors `Data/Attendance/View Models/ShiftReportView.cs::ShiftReportUserView`, which exists to
 * close a PII leak: the report is HR-scoped (it returns rows for OTHER employees) and the endpoint
 * used to serialise the raw EF entity, exposing IBAN, passport/Emirates-ID/Iqama numbers, birth
 * date, address, personal email and push tokens. Typing it as `User` here misdescribed the wire and
 * invited exactly the widening the server type refuses.
 */
export interface ShiftReportUserView {
    id?: string;
    fullName?: string;
    title?: string;
}

export interface ShiftReportView {
    id: number;
    userId?: string;
    user?: ShiftReportUserView;
    clockInTime: Date;
    clockInTimeUtc: Date;
    clockInLongitude?: number;
    clockInLatitude?: number;
    clockInClientType: ClientType;
    clockInImageUrl?: string;
    clockInComments?: string;
    clockInAddress?: string;
    clockInCountry?: string;
    clockInWasOutOfBounds?: boolean;
    clockInOutOfBoundsReason?: string;
    clockInOutOfBoundsDistanceMeters?: number;
    clockOutTime?: Date;
    clockOutTimeUtc?: Date;
    clockOutLongitude?: number;
    clockOutLatitude?: number;
    clockOutClientType: ClientType;
    clockOutImageUrl?: string;
    clockOutComments?: string;
    clockOutAddress?: string;
    clockOutCountry?: string;
    clockOutWasOutOfBounds?: boolean;
    clockOutOutOfBoundsReason?: string;
    clockOutOutOfBoundsDistanceMeters?: number;
    // Out-of-bounds approval (RequireApproval policy) — per-clock-side review state.
    clockInLocationApprovalStatus?: LocationApprovalStatus;
    clockOutLocationApprovalStatus?: LocationApprovalStatus;
    clockInLocationDecidedOnUtc?: Date;
    clockOutLocationDecidedOnUtc?: Date;
    clockInLocationDecisionNote?: string;
    clockOutLocationDecisionNote?: string;
    breaks?: BreakView[];
    scheduledShift?: ScheduledShift;
    createdOn: Date;
    updatedOn?: Date;
    createdById?: string;
    updatedById?: string;
    isArchived: boolean;
    isEdited: boolean;
    hasEnded: boolean;
    workingDuration?: string;
    breaksDuration?: string;
    overtimeDuration?: string;
    // REPORTS REVAMP — what the day was SUPPOSED to be, so the row can show scheduled vs actual and a
    // variance instead of a bare "8h worked" that reads the same against a 6h and a 10h schedule.
    // LOCAL wall-clock in the employee's timezone, the same convention clockInTime/clockOutTime use.
    // OPTIONAL on purpose: absent from an older backend, and NULL when the day carried no schedule at
    // all — which is not the same as a zero-length one (CO-303 turns on exactly that distinction).
    scheduledStartTime?: string | Date | null;
    scheduledEndTime?: string | Date | null;
    /** .NET TimeSpan (`hh:mm:ss` / `d.hh:mm:ss`) — the merged length of the day's scheduled window. */
    scheduledDuration?: string | null;
    totalWorkingDuration: string;
    totalBreaksDuration: string;
    totalOvertimeDuration: string;
}

// ..\mowazaf\Data\Attendance\View Models\ShiftView.cs
export interface ShiftView {
    id: number;
    userId: string;
    user?: User;
    clockInTime: Date;
    clockInTimeUtc: Date;
    clockInLongitude?: number;
    clockInLatitude?: number;
    clockInClientType: ClientType;
    clockInImageUrl?: string;
    clockInComments?: string;
    clockInAddress?: string;
    clockInCountry?: string;
    clockInWasOutOfBounds?: boolean;
    clockInOutOfBoundsReason?: string;
    clockInOutOfBoundsDistanceMeters?: number;
    clockOutTime?: Date;
    clockOutTimeUtc?: Date;
    clockOutLongitude?: number;
    clockOutLatitude?: number;
    clockOutClientType: ClientType;
    clockOutImageUrl?: string;
    clockOutComments?: string;
    clockOutAddress?: string;
    clockOutCountry?: string;
    clockOutWasOutOfBounds?: boolean;
    clockOutOutOfBoundsReason?: string;
    clockOutOutOfBoundsDistanceMeters?: number;
    // Out-of-bounds approval (RequireApproval policy) — per-clock-side review state.
    clockInLocationApprovalStatus?: LocationApprovalStatus;
    clockOutLocationApprovalStatus?: LocationApprovalStatus;
    clockInLocationDecidedOnUtc?: Date;
    clockOutLocationDecidedOnUtc?: Date;
    clockInLocationDecisionNote?: string;
    clockOutLocationDecisionNote?: string;
    breaks?: BreakView[];
    scheduledShift?: ScheduledShift;
    createdOn: Date;
    updatedOn?: Date;
    createdById?: string;
    updatedById?: string;
    isArchived: boolean;
    isEdited: boolean;
    hasEnded: boolean;
    workingDuration?: string;
    breaksDuration?: string;
}

// ..\mowazaf\Data\Attendance\View Models\TimesheetTableView.cs
export interface TimesheetTableView {
    fullName: string;
    from: Date;
    to: Date;
    daysSummaryView: DaySummaryView[];
    daysClockings: ClockingView[][];
    totalWorkTime: string;
}

// ..\mowazaf\Data\Attendance\View Models\UserActivityView.cs
export interface UserActivityView extends UserView {
    shiftId: number;
    latitude: number;
    longitude: number;
    countryName: string;
    lastActivity: ClockingType;
    lastActivityTime: Date;
    lastActivityDuration: string;
    workingDuration?: string;
    iconUrl?: string;
    wialonUnitName?: string;
    wialonLastSeen?: Date;
}

// ..\mowazaf\Data\General\View Models\WialonShiftTrack.cs
export enum WialonHistoryStatus {
    Success = 'Success',
    Disabled = 'Disabled',
    VehicleNotAssigned = 'VehicleNotAssigned',
    VehicleNotFound = 'VehicleNotFound',
    TokenLacksAccess = 'TokenLacksAccess',
    NoData = 'NoData',
    Failure = 'Failure',
}

export interface WialonPositionPoint {
    timeUtc: string;
    latitude: number;
    longitude: number;
    speed: number;
}

export interface WialonTripSummary {
    distanceKm: number;
    maxSpeed: number;
    avgSpeed: number;
    stopCount: number;
    idleTime: string;
    movingTime: string;
    pointCount: number;
}

export interface WialonShiftTrack {
    status: WialonHistoryStatus;
    unitName?: string;
    fromUtc: string;
    toUtc: string;
    points: WialonPositionPoint[];
    summary?: WialonTripSummary;
}

// ..\mowazaf\Data\Attendance\View Models\UserFaceImageView.cs
export interface UserFaceImageView {
    id: number;
    path: string;
    userId: string;
}

// ..\mowazaf\Data\Attendance\View Models\UserLeaveQuotaAndBalanceView.cs
export interface UserLeaveQuotaAndBalanceView {
    id: number;
    eligibility: number;
    quotaUnit: QuotaUnit;
    quotaType: QuotaType;
    isCummulative: boolean;
    annuallyResets: boolean;
    includeNonWorkingrDays: boolean;
    leaveOverlapsOtherLeaves: boolean;
    balance: number;
    inheritedFromCompany: boolean;
    attachmentRequired: boolean;
    userId: string;
    leaveTypeId: number;
}

// ..\mowazaf\Data\Attendance\View Models\UsersMissedClockInNotificationView.cs
export interface UsersMissedClockInNotificationView {
    baseUrl: string;
    timezoneId: string;
    companyId: number;
}

// ..\mowazaf\Data\Attendance\View Models\UsersMissedClockInNotificationViewGroup.cs
export interface UsersMissedClockInNotificationViewGroup {
    baseUrl: string;
    timezoneId: string;
    groupId: number;
}

// ..\mowazaf\Data\Attendance\View Models\OpenShiftView.cs
/**
 * A shift with a clock-in and NO clock-out. The UsersStatuses report filters these out
 * (`ClockOutTimeUtc != null`), which is why the team-attendance grid showed "-" for both punch
 * columns and HR never saw that a half-entered backfill existed.
 */
export interface OpenShiftView {
    id: number;
    userId: string;
    /** Employee-local wall time of the clock-in. */
    clockInTime: Date;
    clockInTimeUtc: Date;
    clockInComments?: string;
    /** When the ROW was inserted, not when the punch claims to have happened. */
    createdOn: Date;
    /** True when the clock-in was backfilled rather than punched live. */
    isBackdatedEntry: boolean;
    hasOpenBreak: boolean;
}

// ..\mowazaf\Data\Attendance\View Models\UsersStatusesReportView.cs
export interface UsersStatusesReportView {
    user: UserView;
    status: UserStatus;
    clockInTimes: Date[];
    clockOutTimes: Date[];
    totalBreaksHours: number;
    totalWorkHours: number;
    overtimeHours: number;
    remarks?: string;
    date: Date;
    leaveRequestView: LeaveRequestView;
}

export interface UsersStatusesPaginatedView {
    items: UsersStatusesReportView[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    attendanceRate: number;
    partialCount: number;
    totalOvertime: number;
}

// ..\mowazaf\Data\Attendance\View Models\WeekScheduleView.cs
export interface WeekScheduleView {
    id: number;
    companyId: number;
    userId?: string;
    weekStartEndHoursAndMinutes: number[][];
}

// ─── Leave Policy Management Types ───

// ..\mowazaf\Data\Attendance\Entities\LeaveEnums.cs
export enum EmploymentType {
    All = 'All',
    FullTime = 'FullTime',
    PartTime = 'PartTime',
    Contract = 'Contract',
    Executive = 'Executive',
}

export enum AccrualFrequency {
    Monthly = 'Monthly',
    Quarterly = 'Quarterly',
    SemiAnnually = 'SemiAnnually',
    Annually = 'Annually',
    OnHireDate = 'OnHireDate',
    Never = 'Never',
}

export enum LeavePayType {
    Paid = 'Paid',
    HalfPaid = 'HalfPaid',
    Unpaid = 'Unpaid',
}

export enum ApproverSource {
    Manager = 'Manager',
    HR = 'HR',
    SpecificUser = 'SpecificUser',
}

export enum StepRoleType {
    Blocking = 'Blocking',
    Advisory = 'Advisory',
    FYI = 'FYI',
}

export enum TimeoutBehavior {
    Escalate = 'Escalate',
    AutoApprove = 'AutoApprove',
    Skip = 'Skip',
}

export enum WorkflowStatus {
    Active = 'Active',
    Completed = 'Completed',
    Cancelled = 'Cancelled',
}

export enum StepStatus {
    Pending = 'Pending',
    Approved = 'Approved',
    Rejected = 'Rejected',
    Skipped = 'Skipped',
    AutoApproved = 'AutoApproved',
}

export enum BlackoutSeverity {
    Strict = 'Strict',
    Advisory = 'Advisory',
    Conditional = 'Conditional',
}

export interface BlackoutCheckResult {
    isBlocked: boolean;
    severity: BlackoutSeverity | null;
    blackoutName: string | null;
    reason: string | null;
}

export interface BlackoutImpactView {
    affectedEmployeeCount: number;
    pendingRequestCount: number;
    blackoutName: string;
    startDate: string;
    endDate: string;
}

// ..\mowazaf\Data\Attendance\View Models\PolicyValidationConfig.cs
export interface PolicyValidationConfig {
    policyId: number;
    policyName: string;
    isActive: boolean;
    minNoticeDays: number;
    maxConsecutiveDays?: number;
    sandwichRuleEnabled: boolean;
    // "Leave for dates with no defined schedule" preview signal (so the form counts days like the
    // backend). leaveWithoutScheduleWorkingDays is a 7-bit mask over JS getDay(). Dates strictly after
    // scheduleCoverageEndUtc are counted per the mask; within coverage the real roster is authoritative.
    allowLeaveWithoutSchedule?: boolean;
    userHasNoSchedule?: boolean;
    scheduleCoverageEndUtc?: string | null;
    leaveWithoutScheduleWorkingDays?: number;
}

export enum HolidayType {
    Public = 'Public',
    National = 'National',
    Religious = 'Religious',
    Company = 'Company',
}

export enum Recurrence {
    Annually = 'Annually',
    Lunar = 'Lunar',
    OneTime = 'OneTime',
}

// ..\mowazaf\Data\Attendance\View Models\LeavePolicyView.cs
export interface LeavePolicyView {
    id: number;
    name: string;
    description?: string;
    legalEntity?: string;
    country?: string;
    employmentType: EmploymentType;
    isDefault: boolean;
    isActive: boolean;
    extendedLeaveThresholdDays?: number;
    monthlyShortLeaveHoursLimit: number;
    maxShortLeaveHoursPerRequest: number;
    shortLeaveNoticePeriodHours: number;
    shortLeaveRequiresApproval: boolean;
    shortLeaveWindowStart?: string;
    shortLeaveWindowEnd?: string;
    createdOn: string;
    updatedOn?: string;
}

// ..\mowazaf\Data\Attendance\Input Models\LeavePolicyInput.cs
export interface LeavePolicyInput {
    name: string;
    description?: string;
    legalEntity?: string;
    country?: string;
    employmentType: EmploymentType;
    isDefault: boolean;
    extendedLeaveThresholdDays?: number;
    monthlyShortLeaveHoursLimit?: number;
    maxShortLeaveHoursPerRequest?: number;
    shortLeaveNoticePeriodHours?: number;
    shortLeaveRequiresApproval?: boolean;
    shortLeaveWindowStart?: string;
    shortLeaveWindowEnd?: string;
}

// ..\mowazaf\Data\Attendance\View Models\AccrualRuleView.cs
export interface PayTierView {
    id: number;
    fromDay: number;
    toDay: number;
    payType: LeavePayType;
}

export interface PayTierInput {
    fromDay: number;
    toDay: number;
    payType: LeavePayType;
}

export interface AccrualRuleEntitlementView {
    id: number;
    leaveTypeId: number;
    leaveTypeName: string;
    entitlementDays: number;
    accrualRate?: string;
    accrualFrequency?: AccrualFrequency;
    eligibilityMonths: number;
    maxAccumulationCap?: number;
    payTiers: PayTierView[];
}

export interface AccrualRuleView {
    id: number;
    leavePolicyId: number;
    name: string;
    roleLevels?: string;
    departmentIds?: string;
    branchIds?: string;
    minYearsOfService: number;
    maxYearsOfService: number;
    employmentTypes?: string;
    ftePercentage: number;
    isActive: boolean;
    probationRestricted: boolean;
    effectiveFrom: string;
    entitlements: AccrualRuleEntitlementView[];
}

// ..\mowazaf\Data\Attendance\Input Models\AccrualRuleInput.cs
export interface AccrualRuleEntitlementInput {
    leaveTypeId: number;
    entitlementDays: number;
    accrualRate?: string;
    accrualFrequency?: AccrualFrequency;
    eligibilityMonths: number;
    maxAccumulationCap?: number;
    payTiers: PayTierInput[];
}

export interface AccrualRuleInput {
    name: string;
    roleLevels?: string;
    departmentIds?: string;
    branchIds?: string;
    minYearsOfService: number;
    maxYearsOfService: number;
    employmentTypes?: string;
    ftePercentage: number;
    isActive: boolean;
    probationRestricted?: boolean;
    effectiveFrom: string;
    entitlements: AccrualRuleEntitlementInput[];
}

// ..\mowazaf\Data\Attendance\View Models\WorkflowView.cs
export interface WorkflowStepView {
    id: number;
    stepOrder: number;
    approverSource: ApproverSource;
    approverValue?: string;
    roleType: StepRoleType;
    timeLimitDays: number;
    timeoutBehavior: TimeoutBehavior;
    escalationTarget?: string;
}

export interface WorkflowView {
    id: number;
    leavePolicyId: number;
    name: string;
    leaveTypes?: string;
    conditionLogic?: string;
    conditions?: string;
    priority: number;
    isDefault: boolean;
    autoApprovalEnabled: boolean;
    autoApprovalMaxDays: number;
    isActive: boolean;
    steps: WorkflowStepView[];
}

// ..\mowazaf\Data\Attendance\Input Models\WorkflowInput.cs
export interface WorkflowStepInput {
    stepOrder: number;
    approverSource: ApproverSource;
    approverValue?: string;
    roleType: StepRoleType;
    timeLimitDays: number;
    timeoutBehavior: TimeoutBehavior;
    escalationTarget?: string;
}

export interface WorkflowInput {
    name: string;
    leaveTypes?: string;
    conditions?: string;
    conditionLogic?: string;
    priority: number;
    isDefault: boolean;
    autoApprovalEnabled: boolean;
    autoApprovalMaxDays: number;
    steps: WorkflowStepInput[];
}

export interface WorkflowTestInput {
    leaveTypeId: number;
    durationDays: number;
}

// ..\mowazaf\Data\Attendance\View Models\CarryForwardRuleView.cs
export interface CarryForwardRuleView {
    id: number;
    leavePolicyId: number;
    leaveTypeId: number;
    leaveTypeName: string;
    isEnabled: boolean;
    calculationType?: string;
    calculationBase?: string;
    calculationValue: number;
    maxCapDays: number;
    expirationMonths: number;
    expirationHandling?: string;
    cashConversionIncludeBasic: boolean;
    cashConversionIncludeAllowances: boolean;
    cashConversionPercentage: number;
    usageOrder?: string;
    autoForfeit: boolean;
    notificationDaysBefore: number;
    minTenureMonths?: number;
    minUtilizationPercent?: number;
    eligibilityLogic?: string;
    prorationMethod?: string;
    fiscalYearStart?: string;
    fiscalYearEnd?: string;
}

// ..\mowazaf\Data\Attendance\Input Models\CarryForwardRuleInput.cs
export interface CarryForwardRuleInput {
    leaveTypeId: number;
    isEnabled: boolean;
    calculationType?: string;
    calculationBase?: string;
    calculationValue: number;
    maxCapDays: number;
    expirationMonths: number;
    expirationHandling?: string;
    cashConversionIncludeBasic: boolean;
    cashConversionIncludeAllowances: boolean;
    cashConversionPercentage: number;
    usageOrder?: string;
    autoForfeit: boolean;
    notificationDaysBefore: number;
    minTenureMonths?: number;
    minUtilizationPercent?: number;
    eligibilityLogic?: string;
    prorationMethod?: string;
    fiscalYearStart?: string;
    fiscalYearEnd?: string;
}

// ..\mowazaf\Data\Attendance\View Models\BlackoutPeriodView.cs
export interface BlackoutPeriodView {
    id: number;
    leavePolicyId?: number;
    name: string;
    startDate: string;
    endDate: string;
    severity: BlackoutSeverity;
    reason?: string;
    departments?: string;
    leaveTypes?: string;
    overridePermissions?: string;
    notificationDaysBefore: number;
    isActive: boolean;
}

// ..\mowazaf\Data\Attendance\Input Models\BlackoutPeriodInput.cs
export interface BlackoutPeriodInput {
    name: string;
    startDate: string;
    endDate: string;
    severity: BlackoutSeverity;
    reason?: string;
    departments?: string;
    leaveTypes?: string;
    overridePermissions?: string;
    notificationDaysBefore: number;
    isActive: boolean;
}

// ..\mowazaf\Data\General\View Models\HolidayView.cs
/**
 * ONE ROW PER (NAME, COUNTRY). A holiday that applies to three countries is three `HolidayView`s
 * sharing a name, each with its own `date` and its own `enabled` flag. Callers that render a flat
 * list will show a multi-country tenant the same holiday N times — group by `name` first.
 */
export interface HolidayView {
    id: number;
    name: string;
    description?: string;
    date?: string;
    holidayType: HolidayType;
    locations?: string;
    recurrence: Recurrence;
    isMandatory: boolean;
    /** The country whose employees this row lands on. Every read path keys on it. */
    countryId: number;
    /** Resolved display name for `countryId`; null when the id resolves to no country row. */
    countryName?: string | null;
    /** `!IsArchived`. Disabled rows ARE returned now — they used to be filtered out server-side. */
    enabled: boolean;
}

export interface HolidayInput {
    name: string;
    description?: string;
    date?: string;
    holidayType: HolidayType;
    /** Comma-separated BRANCH names. Narrows who sees the holiday; does NOT pick a country. */
    locations?: string;
    recurrence: Recurrence;
    isMandatory: boolean;
    /** `false` stages the holiday without applying it to anyone's calendar. */
    enabled: boolean;
    /**
     * Countries to write the holiday to, as country NAMES or ISO2/ISO3 codes — the server resolves
     * them against the global `Countries` reference table (`Name`/`Nicename`/`Iso`/`Iso3`,
     * case-insensitive). Omitted or empty = the server default, which is every country the
     * company's employees belong to plus the company's own. A country with no employees yet is
     * honoured — HR configures a calendar before hiring there.
     *
     * On UPDATE this list is ADDITIVE and is only read when `applyToAllCountries` is true: naming a
     * new country creates its row, but dropping a country from the list does NOT remove its row.
     */
    countries?: string[];
}

// ..\mowazaf\Data\Attendance\View Models\PolicyAuditLogView.cs
export interface PolicyAuditLogView {
    id: number;
    leavePolicyId: number;
    action?: string;
    changedBy?: string;
    changedByName?: string;
    changedAt: string;
    changeDetails?: string;
}

// ..\mowazaf\Data\Attendance\View Models\WorkflowInstanceView.cs
export interface WorkflowInstanceStepView {
    id: number;
    stepOrder: number;
    approverId?: string;
    approverName?: string;
    status: StepStatus;
    dueDate: string;
    actionDate?: string;
    comments?: string;
}

export interface WorkflowInstanceView {
    id: number;
    leaveRequestId: number;
    workflowId: number;
    workflowName: string;
    currentStepOrder: number;
    status: WorkflowStatus;
    submittedDate: string;
    steps: WorkflowInstanceStepView[];
}

// ─── Shared Leave Types (used by API layer) ───

export interface UpcomingHolidayView {
    name: string;
    date: string;
}

export interface LeaveRequestFilterParams {
    status?: LeaveRequestStatus;
    leaveTypeId?: number;
    fromDate?: string;
    toDate?: string;
    pageNumber?: number;
    pageSize?: number;
}

export interface PaginatedResult<T> {
    items: T[];
    totalCount: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
}

export interface TeamMemberLeaveView {
    userId: string;
    userName: string;
    imageUrl?: string;
    leaveType: string;
    startDate: string;
    endDate: string;
}

export interface TeamSummaryView {
    totalTeamMembers: number;
    onLeaveToday: number;
    upcomingLeaves: number;
    pendingApprovals: number;
    coveragePercentage: number;
    currentLeaves: TeamMemberLeaveView[];
    upcomingLeavesList: TeamMemberLeaveView[];
}

export interface PreviousDecisionView {
    leaveRequestId: number;
    userId: string;
    userName: string;
    imageUrl?: string;
    leaveType: string;
    startDate: string;
    endDate: string;
    status: LeaveRequestStatus;
    managerComments?: string;
    decisionDate: string;
}

export interface ConflictView {
    type: string;
    description: string;
    userId?: string;
    userName?: string;
    overlapStart?: string;
    overlapEnd?: string;
    coverageImpactPercent?: number;
}

export interface TeamOverlapView {
    totalTeamMembers: number;
    currentlyOff: number;
    ifApproved: number;
    coverageIfApproved: number;
    members: OverlappingMember[];
}

export interface OverlappingMember {
    userId: string;
    userName: string;
    imageUrl?: string;
    leaveType: string;
    startDate: string;
    endDate: string;
    status: string;
}

export interface EmployeeLeaveContextView {
    daysTakenThisYear: number;
    daysTakenThisMonth: number;
    remainingBalance: number;
    totalEntitlement: number;
    requestsThisQuarter: number;
    recentLeaves: RecentLeaveView[];
}

export interface RecentLeaveView {
    leaveType: string;
    startDate: string;
    endDate: string;
    days: number;
    status: string;
}

export interface TeamCalendarView {
    from: string;
    to: string;
    entries: CalendarEntry[];
    members: TeamMemberInfo[];
    totalMembers: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    departments: TeamDepartmentInfo[];
    nonWorkingDays: number[];
}

export interface TeamDepartmentInfo {
    id: number;
    name: string;
}

export interface TeamMemberInfo {
    userId: string;
    userName: string;
    imageUrl?: string;
    departmentName?: string;
}

export interface CalendarEntry {
    userId: string;
    userName: string;
    imageUrl?: string;
    leaveRequestId: number;
    leaveType: string;
    leaveTypeColor?: string;
    startDate: string;
    endDate: string;
    status: string;
}

// ..\mowazaf\Data\Attendance\View Models\DelegationAssignmentView.cs
export interface DelegationAssignmentView {
    id: number;
    managerId: string;
    managerName: string;
    delegateId: string;
    delegateName: string;
    startDate: string;
    endDate: string;
    isActive: boolean;
    reason?: string;
    createdOn: string;
}

// ..\mowazaf\Data\Attendance\Input Models\DelegationAssignmentInput.cs
export interface DelegationAssignmentInput {
    delegateId: string;
    startDate: string;
    endDate: string;
    reason?: string;
}

// ..\mowazaf\Data\Attendance\View Models\ReturnToWorkRequestView.cs
export interface ReturnToWorkRequestView {
    id: number;
    companyId: number;
    userId: string;
    userName: string;
    userImageUrl?: string;
    leaveRequestId: number;
    leaveType: string;
    leaveStartDate: string;
    leaveEndDate: string;
    managerId?: string;
    managerName?: string;
    status: string;
    thresholdDays: number;
    dueDate: string;
    completedDate?: string;
    managerNotes?: string;
    employeeNotes?: string;
    createdOn: string;
}

// ..\mowazaf\Data\Attendance\ViewModels\CompOffCreditView.cs
export interface CompOffCreditView {
    id: number;
    userId: string;
    userName: string;
    userImageUrl?: string;
    certifiedByManagerId: string;
    certifiedByManagerName: string;
    leaveTypeId: number;
    leaveTypeName: string;
    workDate: string;
    creditDays: number;
    consumedDays: number;
    remainingDays: number;
    issuedDate: string;
    expiryDate: string;
    status: string;
    isExpired: boolean;
    daysUntilExpiry: number;
    notes?: string;
    createdOn: string;
}

// ..\mowazaf\Data\Attendance\Input Models\CompOffCreditInput.cs
export interface CompOffCreditInput {
    userId: string;
    leaveTypeId: number;
    workDate: string;
    creditDays: number;
    expiryDays: number;
    notes?: string;
}

// ..\mowazaf\Data\Attendance\ViewModels\ShortLeaveRequestView.cs
export interface ShortLeaveRequestView {
    id: number;
    userId: string;
    userName: string;
    userImageUrl?: string;
    managerId?: string;
    managerName?: string;
    date: string;
    startTime: string;
    endTime: string;
    hoursRequested: number;
    status: string;
    reason?: string;
    managerComments?: string;
    createdOn: string;
    /** CO-814 — see LeaveRequestView.autoApproved. */
    autoApproved?: boolean;
    autoApprovalReason?: 'ApprovalBypass' | 'WorkflowAutoApproval' | 'PolicyNoApprovalRequired' | null;
    decidedByName?: string | null;
    /** CO-814 — see LeaveRequestView.pendingWith. */
    pendingWith?: 'Manager' | 'Hr' | 'Chief' | 'Unroutable' | null;
}

export interface ShortLeaveUsageView {
    hoursUsedThisMonth: number;
    monthlyLimit: number;
    hoursRemaining: number;
}

// ..\mowazaf\Data\Attendance\Input Models\ShortLeaveRequestInput.cs
export interface ShortLeaveRequestInput {
    date: string;
    startTime: string;
    endTime: string;
    reason?: string;
}

export interface ShortLeaveApprovalInput {
    comments?: string;
}

// ..\mowazaf\Data\Attendance\ViewModels\EncashmentRequestView.cs
export interface EncashmentRequestView {
    id: number;
    userId: string;
    userName: string;
    userImageUrl?: string;
    leaveTypeId: number;
    leaveTypeName: string;
    daysRequested: number;
    balanceBefore: number;
    balanceAfter: number;
    status: string;
    approvedByName?: string;
    approvedOn?: string;
    notes?: string;
    rejectionReason?: string;
    createdOn: string;
    /** CO-814 — approved without a human decision. Encashment is money: HR's bypass does not cover it. */
    autoApproved?: boolean;
    autoApprovalReason?: 'ApprovalBypass' | 'WorkflowAutoApproval' | 'PolicyNoApprovalRequired' | null;
    /** CO-814 — who decided (manager or HR); prefer over `approvedByName`. */
    decidedByName?: string | null;
    /** CO-814 — see LeaveRequestView.pendingWith. */
    pendingWith?: 'Manager' | 'Hr' | 'Chief' | 'Unroutable' | null;
}

export interface EncashmentEligibilityView {
    leaveTypeId: number;
    leaveTypeName: string;
    currentBalance: number;
    balanceFloor: number;
    maxEncashable: number;
}

// ..\mowazaf\Data\Attendance\Input Models\EncashmentRequestInput.cs
export interface EncashmentRequestInput {
    leaveTypeId: number;
    daysRequested: number;
    notes?: string;
}

export interface EncashmentApprovalInput {
    comments?: string;
}

export interface BatchEncashmentPreviewView {
    userId: string;
    userName: string;
    userImageUrl?: string;
    leaveTypeId: number;
    leaveTypeName: string;
    currentBalance: number;
    balanceFloor: number;
    encashableDays: number;
}

export interface BatchEncashmentResultView {
    totalProcessed: number;
    successCount: number;
    failedCount: number;
    results: BatchEncashmentItemResult[];
}

export interface BatchEncashmentItemResult {
    userId: string;
    userName: string;
    leaveTypeId: number;
    leaveTypeName: string;
    daysEncashed: number;
    success: boolean;
    errorMessage?: string;
}

export interface BatchEncashmentInput {
    leaveTypeId: number;
    employees: BatchEncashmentItemInput[];
}

export interface BatchEncashmentItemInput {
    userId: string;
    daysToEncash: number;
}

// Story 7.1 - Recurring Leave Patterns
export interface RecurringLeavePatternView {
    id: number;
    userId: string;
    userName: string;
    leaveTypeId: number;
    leaveTypeName: string;
    recurrenceType: string;
    dayOfWeek?: string;
    dayOfMonth?: number;
    startDate: string;
    endDate: string;
    totalOccurrences: number;
    totalDaysDeducted: number;
    status: string;
    comments?: string;
    occurrences: string[];
    createdOn: string;
}

export interface RecurringLeavePreviewView {
    occurrences: string[];
    totalOccurrences: number;
    totalDaysDeducted: number;
    currentBalance: number;
    balanceAfter: number;
}

export interface RecurringLeavePatternInput {
    leaveTypeId: number;
    recurrenceType: number;
    dayOfWeek?: number;
    dayOfMonth?: number;
    startDate: string;
    endDate: string;
    comments?: string;
}

// Story 7.2 - Restricted Holiday Lists
export interface RestrictedHolidayListView {
    id: number;
    name: string;
    year: number;
    maxSelections: number;
    selectionStartDate: string;
    selectionEndDate: string;
    status: string;
    isSelectionOpen: boolean;
    options: RestrictedHolidayOptionView[];
    mySelectionCount: number;
    mySelectedOptionIds: number[];
}

export interface RestrictedHolidayOptionView {
    id: number;
    holidayId: number;
    holidayName: string;
    date: string;
    totalSelections: number;
}

export interface RestrictedHolidayListInput {
    name: string;
    year: number;
    maxSelections: number;
    selectionStartDate: string;
    selectionEndDate: string;
    holidayIds: number[];
}

export interface RestrictedHolidaySelectionInput {
    optionId: number;
}

// Story 7.3: Statutory Leave Templates
export interface StatutoryLeaveTemplateView {
    id: number;
    countryId: number;
    countryName: string | null;
    countryIso: string | null;
    leaveTypeName: string;
    minDaysPerYear: number;
    carryForwardAllowed: boolean;
    maxCarryForwardDays: number | null;
    probationMonths: number;
    notes: string | null;
}

export interface StatutoryLeaveTemplateInput {
    countryId: number;
    leaveTypeName: string;
    minDaysPerYear: number;
    carryForwardAllowed: boolean;
    maxCarryForwardDays: number | null;
    probationMonths: number;
    notes: string | null;
}

/** The platform catalogue's values for a company copy; null on the copy when the catalogue row is archived. */
export interface StatutoryPlatformValues {
    leaveTypeName: string;
    minDaysPerYear: number;
    carryForwardAllowed: boolean;
    maxCarryForwardDays: number | null;
    probationMonths: number;
    notes: string | null;
}

/**
 * The company's own copy of a catalogue row (owner Q1 a, 2026-10-15). `leaveTypeName` is the copy's own
 * statutory label; `linkedLeaveTypeName` is the name of the company leave type it applies to.
 */
export interface CompanyStatutoryLeaveTemplateView extends StatutoryLeaveTemplateView {
    sourceTemplateId: number;
    leaveTypeId: number | null;
    linkedLeaveTypeName: string | null;
    /** The linked leave type is archived or inactive. */
    linkBroken: boolean;
    isCustomized: boolean;
    sourceSyncedOn: string | null;
    isArchived: boolean;
    /** The catalogue row was archived ("No longer in the platform catalogue"). */
    sourceArchived: boolean;
    platformValues: StatutoryPlatformValues | null;
}

/**
 * PUT api/Leave/StatutoryTemplate/{id}. The PUT replaces every field: a null or missing `leaveTypeId`
 * UNLINKS the copy, so a form must always send the copy's current link.
 */
export interface CompanyStatutoryLeaveTemplateInput {
    leaveTypeName: string;
    minDaysPerYear: number;
    carryForwardAllowed: boolean;
    maxCarryForwardDays: number | null;
    probationMonths: number;
    notes: string | null;
    leaveTypeId: number | null;
}

/** Operator catalogue row (GET api/Operator/StatutoryTemplate): counts only, no company data. */
export interface StatutoryCatalogueTemplateView extends StatutoryLeaveTemplateView {
    isArchived: boolean;
    companyCopyCount: number;
    customizedCopyCount: number;
}

export interface StatutoryComplianceWarning {
    leaveTypeName: string;
    statutoryMinDays: number;
    configuredDays: number;
    warning: string;
    companyTemplateId?: number | null;
    leaveTypeId?: number | null;
}

// Story 8.1: Year-End Processing
export interface YearEndPendingRequestView {
    id: number;
    userId: string;
    userName: string;
    leaveTypeName: string;
    startDate: string;
    endDate: string;
    balanceDeducted: number;
    status: string;
}

export interface YearEndCarryForwardPreviewView {
    userId: string;
    userName: string;
    leaveTypeName: string;
    leaveTypeId: number;
    currentBalance: number;
    carryForwardAmount: number;
    forfeitureAmount: number;
    encashedDays: number;
    carryForwardExpiry: string | null;
    isEligible: boolean;
    ineligibilityReason: string | null;
}

export interface YearEndPreviewView {
    year: number;
    pendingRequests: YearEndPendingRequestView[];
    carryForwardPreviews: YearEndCarryForwardPreviewView[];
    totalEmployees: number;
    totalCarryForwardDays: number;
    totalForfeitureDays: number;
    totalEncashedDays: number;
}

export interface YearEndEmployeeResultView {
    userId: string;
    userName: string;
    leaveTypeName: string;
    carryForwardDays: number;
    forfeitedDays: number;
    success: boolean;
    errorMessage: string | null;
}

export interface YearEndExecutionResultView {
    runId: number;
    year: number;
    status: string;
    totalEmployees: number;
    carryForwardProcessed: number;
    forfeitureProcessed: number;
    failedCount: number;
    employeeResults: YearEndEmployeeResultView[];
    completedOn: string | null;
}

export interface YearEndProcessingRunView {
    id: number;
    year: number;
    status: string;
    totalEmployees: number;
    carryForwardProcessed: number;
    forfeitureProcessed: number;
    failedCount: number;
    completedOn: string | null;
    executedByName: string | null;
    createdOn: string;
}

// Story 8.2: Leave Statements
export interface LeaveStatementView {
    id: number;
    userId: string;
    userName: string;
    year: number;
    leaveTypeName: string;
    leaveTypeId: number;
    openingBalance: number;
    accruals: number;
    consumed: number;
    carryForward: number;
    forfeited: number;
    encashed: number;
    adjustments: number;
    closingBalance: number;
}

export interface LeaveStatementSummaryView {
    userId: string;
    userName: string;
    year: number;
    branchId: number | null;
    branchName: string | null;
    departmentId: number | null;
    departmentName: string | null;
    statements: LeaveStatementView[];
}

export interface GenerateStatementsResultView {
    year: number;
    totalEmployees: number;
    statementsGenerated: number;
    failedCount: number;
}

// Story 8.3: Absenteeism Analytics
export interface DepartmentAbsenceRateView {
    departmentId: number;
    departmentName: string;
    employeeCount: number;
    totalAbsenceDays: number;
    absenceRate: number;
    averageAbsenceDays: number;
}

export interface AbsencePatternView {
    userId: string;
    userName: string;
    departmentName: string | null;
    patternType: string;
    description: string;
    occurrences: number;
}

export interface MonthlyAbsenceView {
    month: number;
    monthName: string;
    totalDays: number;
    requestCount: number;
}

export interface AbsenteeismAnalyticsView {
    year: number;
    companyAbsenceRate: number;
    totalAbsenceDays: number;
    totalEmployees: number;
    departmentRates: DepartmentAbsenceRateView[];
    flaggedPatterns: AbsencePatternView[];
    monthlyTrend: MonthlyAbsenceView[];
}

// Story 8.4: Bradford Factor & Cost of Absence
export interface BradfordFactorView {
    userId: string;
    userName: string;
    departmentName: string | null;
    spellCount: number;
    totalDays: number;
    bradfordScore: number;
    riskBand: string;
}

// Absence volume per department - no money. The previous averageDailyRate/estimatedCost
// fields were a hardcoded 500/day placeholder rendered as currency; see
// AbsenteeismAnalyticsService.GetBradfordFactorReport.
export interface DepartmentAbsenceSummaryView {
    departmentId: number;
    departmentName: string;
    totalAbsenceDays: number;
    employeeCount: number;
}

export interface BradfordFactorReportView {
    year: number;
    employees: BradfordFactorView[];
    departmentBreakdown: DepartmentAbsenceSummaryView[];
}
